(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.SppAnalysisService = (function(superClass) {
    extend(SppAnalysisService, superClass);

    function SppAnalysisService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this.fetchDeveloperData = bind(this.fetchDeveloperData, this);
      this.getProgramForUser = bind(this.getProgramForUser, this);
      this.fetchProgramsUsers = bind(this.fetchProgramsUsers, this);
      this.getCompanies = bind(this.getCompanies, this);
      void 0;
    }

    SppAnalysisService.prototype.getCompanies = function() {
      return this.http.post('backend/admin/spp-analysis/get-companies');
    };

    SppAnalysisService.prototype.fetchProgramsUsers = function(program, company) {
      return this.http.post('backend/admin/spp-analysis/fetch-programs-users', {
        program: program,
        company: company
      });
    };

    SppAnalysisService.prototype.getProgramForUser = function(user, rep, program, fsr) {
      if (user == null) {
        user = null;
      }
      if (rep == null) {
        rep = null;
      }
      if (program == null) {
        program = null;
      }
      if (fsr == null) {
        fsr = null;
      }
      return this.http.post('backend/admin/spp-analysis/get-program-for-user', {
        user: user,
        rep: rep,
        program: program,
        fsr: fsr
      });
    };

    SppAnalysisService.prototype.fetchDeveloperData = function(pp_id) {
      return this.http.post('backend/admin/spp-analysis/get-developer-data', {
        pp_id: pp_id
      });
    };

    return SppAnalysisService;

  })(Service);

}).call(this);
